import React from 'react';
import { useTranslation } from 'react-i18next';
import MenuTabs from './Menu/MenuTabs';
import { Helmet } from 'react-helmet-async';
import Hero from './Component/Hero';

export default function Home() {
  const { t, i18n } = useTranslation();

  // Determine current hour for dynamic greeting
  const hour = new Date().getHours();
  let greetingKey = 'morning';
  if (hour >= 12 && hour < 18) greetingKey = 'afternoon';
  else if (hour >= 18 || hour < 5) greetingKey = 'evening';

  const isArabic = i18n.language === 'ar';

  return (
    <>
      {/* SEO Meta */}
      <Helmet>
        <title>Felfela Kraków - Zdrowe i Pyszne Jedzenie</title>
        <meta 
          name="description" 
          content="Felfela Kraków - odkryj zdrowe i pyszne jedzenie, przygotowane z najwyższej jakości składników przez Mostafę i Walida. Sprawdź nasze menu już dziś!" 
        />
        <meta property="og:title" content="Felfela Kraków - Zdrowe i Pyszne Jedzenie" />
        <meta 
          property="og:description" 
          content="Felfela Kraków - odkryj zdrowe i pyszne jedzenie, przygotowane z najwyższej jakości składników przez Mostafę i Walida." 
        />
        <meta property="og:image" content="https://felfela.pl/FelfelaOG.jpg" />
  <meta property="og:url" content="https://felfela.pl/" />
  <meta property="og:type" content="website" />
      </Helmet>
<Hero/>
      <main className={`max-w-[1200px] mx-auto lg:px-0 px-4 py-10 ${isArabic ? 'arabic-font text-right' : 'falafel-font text-left'}`} dir={isArabic ? 'rtl' : 'ltr'}>
        
        {/* Welcome Message */}
        <section className="mb-12">
          <h2 className="text-3xl font-bold mb-4">{t(`welcome.${greetingKey}`)}</h2>
          <p className="mb-4 text-xl">{t('welcome.paragraph1')}</p>
          <p className="mb-4 text-xl">{t('welcome.paragraph2')}</p>
          <p className='text-xl'>{t('welcome.paragraph3')}</p>
        </section>

        {/* Menu Tabs */}
        <MenuTabs />
      </main>
    </>
  );
}
